module.exports = __webpack_public_path__ + "img/party_bg.ccf31b9b.jpg";